module.exports = __webpack_public_path__ + "static/media/camcorder.8b4e5790.svg";